module.exports = __webpack_public_path__ + "static/media/trave night shot editt.486fe045.webp";